<template>
  <div class="scroll-container" ref="scrollContainer">
    <div class="scroll-slider" :key="renderKey" :style="`transform: translateX(-${scrollTranslate}px)`" ref="scrollSlider">
      <slot />
    </div>

    <div class="scroller-button left-button" @click="left" v-if="hasLeft">
      <slot name="scroll-button-left"><scroll-button-icon left color="purple" /></slot>
    </div>
    <div class="scroller-button right-button" @click="right" v-if="hasRight">
      <slot name="scroll-button-right"><scroll-button-icon color="purple" /></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'scroll-container',
  props: {
    horizontalPadding: {
      type: Number,
      default: 56
    }
  },
  data() {
    return {
      scrollContainerWidth: 0,
      itemWidth: 0,
      childrenCount: 0,
      renderKey: true,
      currentPage: 0
    }
  },
  computed: {
    maxPages() {
      const scrollContainerWidth = this.scrollContainerWidth
      const itemWidth = this.itemWidth
      const childrenCount = this.childrenCount

      let itemsPerPage = Math.floor(scrollContainerWidth / itemWidth)
      if (itemsPerPage > 0) {
        return Math.ceil(childrenCount / itemsPerPage)
      } else {
        return 0
      }
    },
    hasRight() {
      return (this.currentPage < this.maxPages - 1)
    },
    hasLeft() {
      return (this.currentPage > 0)
    },
    scrollTranslate() {
      const scrollContainerWidth = this.scrollContainerWidth
      const itemWidth = this.itemWidth

      const itemsPerPage = Math.floor(scrollContainerWidth / itemWidth)
      const scrollSize = itemsPerPage * itemWidth

      let maxScroll = 0
      if (this.$refs.scrollSlider) {
        maxScroll = this.$refs.scrollSlider.offsetWidth - scrollContainerWidth
      }

      return Math.max(Math.min(this.currentPage * scrollSize, maxScroll), 0)
    }
  },
  methods: {
    right() {
      if (this.hasRight) {
        this.currentPage++
      }
    },
    left() {
      if (this.hasLeft) {
        this.currentPage--
      }
    },
    resetScroll() {
      this.renderKey = !this.renderKey
      this.$nextTick(this.calculateMountProperties)
      this.currentPage = 0
    },
    calculateMountProperties() {
      const scrollSlider = this.$refs.scrollSlider
      if (scrollSlider) {
        this.childrenCount = scrollSlider.children.length
        this.itemWidth = scrollSlider.children[0].offsetWidth
      }

      const scrollContainer = this.$refs.scrollContainer
      if (scrollContainer) {
        this.scrollContainerWidth = scrollContainer.offsetWidth - (2 * this.horizontalPadding)
      }
    }
  },
  mounted() {
    this.calculateMountProperties()
  }
}
</script>

<style lang="scss">
.scroll-container {
  position: relative;
  padding-left: 56px;
  padding-right: 56px;
  display: flex;
  width: 100%;
  max-width: 100%;
  overflow: visible;

  & > .scroll-slider {
    position: relative;
    display: inline-flex;
    z-index: 1;
    transition: transform 0.6s ease-in-out;
  }

  & > .scroller-button {
    position: absolute;
    width: 72px;
    height: 92px;
    top: calc(50% - 46px);
    cursor: pointer;
    z-index: 2;
    transform: translate3d(0, 0, 0);

    &.left-button {
      left: -5px;
      transform: translate3d(0, 0, 0);
    }

    &.right-button {
      right: -6px;

      &:active {
        transform: translateY(5px);
      }
    }

    &:active {
      transform: translateY(5px) rotateY(180deg);
    }
  }

  @media (hover: none),
         (max-width: 425px) and (orientation: portrait),
         (max-width: 812px) and (orientation: landscape) {
    padding: 16px 16px 28px 16px;
    margin-top: -8px;
    margin-bottom: -12px;
    overflow-y: visible;
    overflow-x: auto;
    scrollbar-width: none;
    -ms-overflow-style: none;

    &::-webkit-scrollbar {
      width: 0;
      height: 0;
    }

    & > .scroller-button {
      display: none;
    }
  }
}
</style>
